/**
 * InterviewThankYou - Completion page shown after the interview ends.
 */

import { CheckCircle } from 'lucide-react'

// ============================================================================
// COMPONENT
// ============================================================================

interface InterviewThankYouProps {
  messageCount?: number
}

export function InterviewThankYou({ messageCount }: InterviewThankYouProps) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-warm-50 p-4">
      <div className="flex max-w-md flex-col items-center gap-5 rounded-2xl bg-white p-10 text-center shadow-sm">
        <CheckCircle className="h-14 w-14 text-green-500" />

        <h1 className="font-display text-2xl font-semibold text-warm-800">
          Thank you!
        </h1>

        <p className="text-sm leading-relaxed text-warm-500">
          Your interview has been completed. Your responses will help inform our research.
        </p>

        {messageCount !== undefined && messageCount > 0 && (
          <p className="text-xs text-warm-400">
            {messageCount} {messageCount === 1 ? 'message' : 'messages'} recorded
          </p>
        )}
      </div>
    </div>
  )
}
